// Отпечаток устройства для антифрода (мультиаккаунты): стабильный хеш характеристик браузера.
let cached: string | null = null;

function hash(s: string): string {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 2654435761);
    h2 = Math.imul(h2 ^ c, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (h2 >>> 0).toString(16).padStart(8, '0') + (h1 >>> 0).toString(16).padStart(8, '0');
}

function canvasSignal(): string {
  try {
    const c = document.createElement('canvas');
    c.width = 120;
    c.height = 30;
    const ctx = c.getContext('2d');
    if (!ctx) return '';
    ctx.textBaseline = 'top';
    ctx.font = '16px Georgia';
    ctx.fillStyle = '#e0b44c';
    ctx.fillText('Морские Короли ⚓', 2, 4);
    return c.toDataURL().slice(-64);
  } catch {
    return '';
  }
}

export function getFingerprint(): string {
  if (cached) return cached;
  const stored = localStorage.getItem('sk_fp');
  const parts = [
    navigator.userAgent,
    navigator.language,
    screen.width,
    screen.height,
    screen.colorDepth,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.hardwareConcurrency,
    canvasSignal(),
  ].join('|');
  cached = stored ?? `fp_${hash(parts)}`;
  if (!stored) localStorage.setItem('sk_fp', cached);
  return cached;
}
